import { ConversationGoals as ConversationGoalsGraphQL } from '@cpd-app/generated';

import { ConversationGoals } from '../models/ai-chat/conversation-goals';

export class ConversationGoalsMapper {
  static toConversationGoals(
    goals: ConversationGoalsGraphQL
  ): ConversationGoals {
    if (!goals) {
      return null;
    }

    return {
      onetCode: goals.onetCode,
      schoolId: +goals.schoolId,
      edlevelId: +goals.edlevelId,
      programId: +goals.programId,
      certificationId: +goals.certificationId,
      hasChanged: goals.hasChanged
    };
  }
}
